import RecepcionComponent from "@/components/wms/recepcion/RecepcionComponent";
import RecepcionFormComponent from "@/components/wms/recepcion/RecepcionFormComponent";
import RecepcionDashboardProductosLote from "@/components/wms/recepcion/RecepcionDashboardProductosLote";
import RecepcionAgregarProductoDetalle from "@/components/wms/recepcion/RecepcionAgregarProductoDetalle.vue";

import AgendaProveedorComponent from "@/components/wms/agenda/AgendaProveedorComponent";
import AgendaProveedorNuevoComponent from "@/components/wms/agenda/AgendaProveedorNuevoComponent";

import TareasDashBoardComponent from "@/components/wms/tareas/TareasDashBoardComponent";

import TareaManualComponent from "@/components/wms/tareas_manuales/TareaManualComponent";
import TareaManualFormComponent from "@/components/wms/tareas_manuales/TareaManualFormComponent";

import TarimasComponent from "@/components/wms/tarimas/TarimasComponent";
import InconsistenciasComponent from "@/components/wms/tarimas/InconsistenciasComponent";

import ContenedorComponent from "@/components/wms/contenedor/ContenedorComponent";
import ContenedorFormComponent from "@/components/wms/contenedor/ContenedorFormComponent";

import RecepcionContenedorComponent from "@/components/wms/recepcioncontenedor/RecepcionContenedorComponent";
import RecepcionBuscarContenedorComponent from "@/components/wms/recepcioncontenedor/RecepcionBuscarContenedorComponent";
import RecepcionBuscarTarimaComponent from "@/components/wms/recepciontarima/RecepcionBuscarTarimaComponent";
import RecepcionTarimaComponent from "@/components/wms/recepciontarima/RecepcionTarimaComponent";

import DevolucionTarimasComponent from "@/components/wms/devoluciontarima/DevolucionTarimasComponent";

import AutorizarRecepcionComponent from "@/components/wms/autorizar_linea/AutorizarRecepcionComponent";
import InventarioPorPosicionesComponent from "@/components/wms/dashboard/InventarioPorPosicionesComponent";

import AbrirTarimaComponent from "@/components/wms/tarimas/AbrirTarimaComponent";

import devolucionProveedorComponent from "@/components/wms/devolucion_proveedor/devolucionProveedorComponent";
import devolucionProveedorFormComponent from "@/components/wms/devolucion_proveedor/devolucionProveedorFormComponent";

import EnvioDespachosDashBoardComponent from "@/components/wms/envio_despacho/EnvioDespachosDashBoardComponent";

import despachosDashBoardComponent from "@/components/wms/despachos/DespachosDashBoardComponent";

import RptGenerarReferenciaFacturaComponent from "@/components/wms/reportes/RptGenerarReferenciaFacturaComponent";

import PedidoRepartoComponent from "@/components/wms/asignar_pedido_reparto/PedidoRepartoComponent";
import PedidoRepartoFormComponent from "@/components/wms/asignar_pedido_reparto/PedidoRepartoFormComponent";

import DevolucionesComponent from "@/components/wms/devoluciones_clientes/DevolucionesComponent";
import DevolucionesFormComponent from "@/components/wms/devoluciones_clientes/DevolucionesFormComponent";

import TransferenciaStockDashBoardComponent from "@/components/wms/transferencia_stock/TransferenciaStockDashBoardComponent";

import TransferenciaLocComponent from "@/components/wms/transferencia_localizacion/TransferenciaLocComponent";
import TransferenciaLocFormComponent from "@/components/wms/transferencia_localizacion/TransferenciaLocFormComponent";

import TareaUsuarioComponent from "@/components/wms/utilidades/Asignar_tarea_usuario/TareaUsuarioComponent";
import TareaUsuarioFormComponent from "@/components/wms/utilidades/Asignar_tarea_usuario/TareaUsuarioFormComponent";

import DevolucionRecepcionComponent from "@/components/wms/devolucion_recepcion/DevolucionRecepcionComponent";
import DevolucionRecepcionFormComponent from "@/components/wms/devolucion_recepcion/DevolucionRecepcionFormComponent";

import DevolucionDespachoDashBoardComponent from "@/components/wms/devolucion_despacho_mayoreo/DevolucionDespachoDashBoardComponent";
import DevolucionDespachoFormComponent from "@/components/wms/devolucion_despacho_mayoreo/DevolucionDespachoFormComponent";

import ClonarCategoriasComponent from "@/components/wms/utilidades/Asignar_tarea_usuario/ClonarCategoriasComponent";
import CategoriasUsuarioEdicionComponent from "@/components/wms/utilidades/Asignar_tarea_usuario/CategoriasUsuarioEdicionComponent";
import AsignacionCategoriaUsuario from "@/components/wms/utilidades/Asignar_tarea_usuario/AsignacionCategoriaUsuario";

export default [
  {
    path: "/wms/recepcion/nuevo",
    name: "wms-recepcion-nuevo",
    component: RecepcionComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/recepcion/:id/",
    name: "wms-recepcion-editar",
    component: RecepcionFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/recepcion/",
    name: "wms-recepcion",
    component: RecepcionComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/dashboard-lote/",
    name: "wms-recepcion-dashboard-lote",
    component: RecepcionDashboardProductosLote,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/recepcion/recepcion-producto/:sku?/:facturaeId?",
    name: "RecepcionAgregarProductoDetalle",
    component: RecepcionAgregarProductoDetalle,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/agenda/",
    name: "wms-agenda",
    component: AgendaProveedorComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/agenda/nuevo/:id/",
    name: "wms-agenda-nuevo",
    component: AgendaProveedorNuevoComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/tareas/",
    name: "wms-tareas",
    component: TareasDashBoardComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/tareas/:id",
    name: "wms-tareas-editar",
    component: TareasDashBoardComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/tareas-manuales/",
    name: "wms-tareas-manuales",
    component: TareaManualComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/tareas-manuales/:id",
    name: "wms-tareas-manuales-editar",
    component: TareaManualFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/tarimas/",
    name: "wms-tarimas",
    component: TarimasComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/tarimas/:id",
    name: "wms-tarimas-editar",
    component: TarimasComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/inconsistencias-tarima/",
    name: "wms-inconsistencias",
    component: InconsistenciasComponent,
    meta: {
      requiresAuth: true,
      permission: 'InconsistenciasTarima', // Optional: if you want to restrict by permission key
    },
  },
  {
    path: "/wms/inconsistencias-tarima/:id",
    name: "wms-inconsistencias-detalle",
    component: InconsistenciasComponent, // Using same component, logic handles detail view
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/devolucion-tarima/",
    name: "wms-devolucion-tarima",
    component: DevolucionTarimasComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/devolucion-tarima/:id",
    name: "wms-devolucion-tarima-editar",
    component: DevolucionTarimasComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/recepcion-contenedor/buscar/",
    name: "wms-recepcion-contenedor-buscar",
    component: RecepcionBuscarContenedorComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/recepcion-contenedor/contenedor/:id/",
    name: "wms-recepcion-contenedor-contenedor",
    component: RecepcionContenedorComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/contenedor/",
    name: "wms-contenedor",
    component: ContenedorComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/contenedor/editar/:id/",
    name: "wms-contenedor-editar",
    component: ContenedorFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/recepcion-tarima/buscar/",
    name: "wms-recepcion-tarima-buscar",
    component: RecepcionBuscarTarimaComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/recepcion-tarima/tarima/:id/",
    name: "wms-recepcion-tarima-tarima",
    component: RecepcionTarimaComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/recepcion-autorizar/",
    name: "wms-recepcion-autorizar",
    component: AutorizarRecepcionComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/dashboard/posiciones/",
    name: "wms-dashboard-posiciones",
    component: InventarioPorPosicionesComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/tarima-abrir/",
    name: "wms-tarima-abrir",
    component: AbrirTarimaComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/devolucion-provedor/",
    name: "wms-devolucion-provedor",
    component: devolucionProveedorComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/devolucion-provedor/:id/",
    name: "wms-devolucion-provedor-editar",
    component: devolucionProveedorFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/despachos/",
    name: "wms-despacho",
    component: despachosDashBoardComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/despachos/:id/",
    name: "wms-despacho-editar",
    component: despachosDashBoardComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/reporte-etiqueta-referecia/",
    name: "wms-reporte-etiqueta-referecia",
    component: RptGenerarReferenciaFacturaComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/envio-despachos/",
    name: "wms-envio-despachos",
    component: EnvioDespachosDashBoardComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/envio-despachos/:id/",
    name: "wms-envio-despachos-editar",
    component: EnvioDespachosDashBoardComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/asignar-pedido-reparto/",
    name: "wms-asignar-pedido-reparto",
    component: PedidoRepartoComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/asignar-pedido-reparto/:id",
    name: "wms-asignar-pedido-reparto-editar",
    component: PedidoRepartoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/devoluciones/",
    name: "wms-devoluciones",
    component: DevolucionesComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/devoluciones/editar/:id/",
    name: "wms-devoluciones-editar",
    component: DevolucionesFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/transferencia-stock/",
    name: "wms-transferencia-stock",
    component: TransferenciaStockDashBoardComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/transferencia-stock/:id/",
    name: "wms-transferencia-stock-editar",
    component: TransferenciaStockDashBoardComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/movimiento-localizacion/",
    name: "wms-movimiento-localizacion",
    component: TransferenciaLocComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/movimiento-localizacion/:id/",
    name: "wms-movimiento-localizacion-editar",
    component: TransferenciaLocFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/tarea-usuario/",
    name: "wms-tarea-usuario",
    component: TareaUsuarioComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/categoria-usuario/",
    name: "wms-categoria-usuario",
    component: AsignacionCategoriaUsuario,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/tarea-usuario/editar/:id/",
    name: "wms-tarea-usuario-editar",
    component: TareaUsuarioFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/tarea-usuario/nuevo",
    name: "wms-tarea-usuario-nuevo",
    component: TareaUsuarioFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/tarea-usuario/asignar-tareas",
    name: "wms-tarea-usuario-asignar-tareas",
    component: ClonarCategoriasComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/tarea-usuario/editar-categorias/:id/",
    name: "wms-tarea-usuario-editar-tareas",
    component: CategoriasUsuarioEdicionComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/recepcion_devolucion/",
    name: "inventario-recepcion_devolucion",
    component: DevolucionRecepcionComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inventario/recepcion_devolucion/:id",
    name: "inventario-recepcion_devolucion-editar",
    component: DevolucionRecepcionFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/devolucion-mayoreo/",
    name: "wms-devolucion-mayoreo",
    component: DevolucionDespachoDashBoardComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/wms/devolucion-mayoreo/:id/",
    name: "wms-envio-devolucion-mayoreo-editar",
    component: DevolucionDespachoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
];
